(function(){

	SUGApp.service('commonRegExService', ['SUGUtilities', function (SUGUtilities) {

		var factory = {};

		factory.addressRegEx = function() {
			var pattern = new RegExp ("^[0-9].*$", "i");
			return pattern;
		};
		factory.bankAccountNumberRegEx = function() {
			var pattern = new RegExp ("^[0-9]{3,17}$");
			return pattern;
		};
		factory.bankRoutingNumberRegEx = function() {
			var pattern = new RegExp ("^[0-9]{9}$");
			return pattern;
		};
		factory.caGSTHSTNumberRegEx = function() {
			var pattern = new RegExp ("^[0-9]{9}\s?[A-Z]{2}\s?[0-9]{4}$");
			return pattern;
		};
		factory.caGSTHSTNumberLowerCaseRegEx = function() {
			var pattern = new RegExp ("^[0-9]{9}\s?[a-z]{2}\s?[0-9]{4}$");
			return pattern;
		};
		factory.caBankAccountNumberRegEx = function() {
			var pattern = new RegExp ("^[0-9]{5,12}$");
			return pattern;
		};
		factory.caBankTransitRegEx = function() {
			var pattern = /^[0-9]{5}$/;
			return pattern;
		};
		factory.caInstitutionNumberRegEx = function() {
			var pattern = /^[0-9]{3}$/;
			return pattern;
		};
		factory.caPostalCodeRegEx = function() {
			var pattern = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}\s*\d{1}[A-Z]{1}\d{1}$/;
			return pattern;
		};
		factory.caSinRegEx = function() {
			var pattern = /^(\d{3})[\-\s]?(\d{3})[\-\s]?(\d{3})$/;
			return pattern;
		};

		factory.cityRegEx = function() {
			var pattern = new RegExp ("^[a-zA-Z\- ]+$");
			return pattern;
		};
		factory.einRegEx = function() {
			var pattern = new RegExp ("[0-9]{9}");
			return pattern;
		};
		factory.emailRegEx = function() {
			var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return pattern;
		};
		factory.noSpecialCharsForFileRegEx = function() {
			var pattern = new RegExp ("^[a-zA-Z0-9\- \_]+$");	//= /^[a-zA-Z0-9\ \_\-]*$/;
			return pattern;
		};

		factory.phoneRegEx = function() {
			var pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
			return pattern;
		};
		factory.poboxRegEx = function() {
			var pattern = /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i;
			return pattern;
		};
		factory.ssnFullRegEx = function() {
			var pattern = new RegExp("^(?!\\b(\\d)\\1+\\b)(?!123456789|219099999|078051120)(?!666|000|9\\d{2})\\d{3}(?!00)\\d{2}(?!0{4})\\d{4}$");
			return pattern;
		};
		factory.ssnLast4RegEx = function() {
			var pattern = new RegExp("[0-9]{4}");
			return pattern;
		};
		factory.uriRegEx = function() {
			var pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
			return pattern;
		};
		factory.zipcodeRegEx = function() {
			var pattern = new RegExp ("^[0-9]{5}(?:-[0-9]{4})?$");
			return pattern;
		};

		/**
		 * Validates a Canadian Postal Code using the following rules:
		 * A Canadian postal code is a six-character string in the format A1A 1A1, where A is a letter and 1 is a digit
		 * A space separates the third and fourth characters
		 * Postal codes do not include the letters D, F, I, O, Q or U
		 * The first position also does not make use of the letters W or Z
		 * src: https://howtodoinjava.com/regex/java-regex-validate-canadian-postal-zip-codes/
		 */
		factory.canadianPostalCodeRegEx = function() {
			var pattern = new RegExp ("^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$");
			return pattern;
		};

		/**
		 * Validates a US Zip Code OR a Canadian Postal Code using the individual validation functions
		 */
		factory.validateZipOrPostalCode = function( code ) {
			if( typeof code == 'undefined' ){ code=0; }
			var returnVar = false;

			if (/^\d/.test(code)){
				returnVar = factory.zipcodeRegEx().test(code);
			} else {
				returnVar = factory.canadianPostalCodeRegEx().test(code);
			}

			return returnVar;
		};

		return factory;
	}]);

}()); //self invoked function to keep variables/modules out of the global scope
